// =========================================================================
// F08 G3 · Borrador del wizard de onboarding (posición + objetivo)
// =========================================================================
// Complementa a G2 (reanudación): con el borrador, quien retoma el onboarding
// vuelve a la PANTALLA donde lo dejó y con su `goal` ya elegido, en vez de
// empezar de cero. Es un BORRADOR local (data-layer.md lo permite: caché,
// borradores o cola); no es fuente de verdad — el dato definitivo se sella en
// `finalizar` (perfil + valoración). Se limpia al completar el wizard.
//
// Sigue la convención de claves de `features/progreso/almacen.ts`
// (`helpydoc_data_<recurso>`) y su misma tolerancia a fallos: un almacén
// ilegible se trata como vacío, nunca tira la pantalla abajo.

import type { UserGoal } from '@/services';

const CLAVE = 'helpydoc_data_onboarding_borrador';

const OBJETIVOS_VALIDOS: readonly UserGoal[] = ['lose', 'maintain', 'gain'];

export interface BorradorOnboarding {
  /** Índice de pantalla del wizard (0-based). */
  step: number;
  /** Objetivo elegido hasta el momento. */
  goal: UserGoal;
}

/**
 * Normaliza un objeto crudo a un borrador válido, o `null` si no lo es. Puro:
 * no toca `localStorage`, así se prueba sin navegador.
 */
export function parseBorradorOnboarding(bruto: unknown): BorradorOnboarding | null {
  if (typeof bruto !== 'object' || bruto === null) return null;
  const b = bruto as Record<string, unknown>;
  const step = b.step;
  const goal = b.goal;
  if (typeof step !== 'number' || !Number.isInteger(step) || step < 0) return null;
  if (typeof goal !== 'string' || !OBJETIVOS_VALIDOS.includes(goal as UserGoal)) return null;
  return { step, goal: goal as UserGoal };
}

export function leerBorradorOnboarding(): BorradorOnboarding | null {
  try {
    const bruto = localStorage.getItem(CLAVE);
    if (!bruto) return null;
    return parseBorradorOnboarding(JSON.parse(bruto));
  } catch {
    return null;
  }
}

export function guardarBorradorOnboarding(borrador: BorradorOnboarding): void {
  try {
    localStorage.setItem(CLAVE, JSON.stringify(borrador));
  } catch (err) {
    console.warn('[onboarding] no se pudo guardar el borrador:', err);
  }
}

/** Borra el borrador. Se llama al completar el wizard (o al borrar datos). */
export function limpiarBorradorOnboarding(): void {
  try {
    localStorage.removeItem(CLAVE);
  } catch {
    /* sin almacén no hay nada que limpiar */
  }
}
